/**
 * ****************************************************************************
 * @description     :   All action on page reports
 * @created at      :   2020/07/18
 * @created by      :   QuanHVM
 * @package         :   report-daily-react
 * @copyright       :   Copyright (c)
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import type of actions
 */
import Types from './action-types';

/**
 * Actions to get data needed for page chats
 * -----------------------------------------
 * @author : QuanHVM - create
 * @access : public
 */
const Actions = {
    /**
     * Actions get data of reports
     * -----------------------------------------
     * @author : QuanHVM - 2022/07/18 - create
     * @returns: {Object} - Action to require saga get data of reports
     * @access : public
     */
    GetReports: (condition) => ({
        type: Types.FETCHING_REPORTS,
        condition
    }),
    /**
     * Actions change data of reports when get data success
     * -----------------------------------------
     * @author : QuanHVM - 2022/07/18 - create
     * @param  : {Array} reports - Data of reports
     * @returns: {Object} - Action to change data of reports when get data success
     * @access : public
     */
    GetReportsSuccess: (reports) => ({
        type: Types.FETCHING_REPORTS_SUCCESS,
        data: reports
    }),
    /**
     * Actions reset data of reports when get data failure
     * -----------------------------------------
     * @author : QuanHVM - 2022/07/18 - create
     * @param  : {Array} error - Data of error
     * @returns: {Object} - Action to reset data of reports when get data failure
     * @access : public
     */
    GetReportsFailure: (error) => ({
        type: Types.FETCHING_REPORTS_FAILURE,
        data: error
    }),
    /**
     * Actions Set data checkbox of reports when event change input checkbox
     * -----------------------------------------
     * @author : QuanHVM - 2022/07/21 - create
     * @param  : {Array} error - Data of error
     * @returns: {Object} - Action to set data checkbox of reports when event change input checkbox
     * @access : public
     */
    UpdateDataCheckbox: (reports) => ({
        type: Types.CHECKBOX_REPORT,
        reports
    }),
    /**
     * Actions destroy data checkbox of reports when event change input checkbox
     * -----------------------------------------
     * @author : QuanHVM - 2022/07/21 - create
     * @param  : {Array} error - Data of error
     * @returns: {Object} - Action to set data checkbox of reports when event change input checkbox
     * @access : public
     */
    DestroyReport: (listRemoves) => ({
        type: Types.DESTROY_REPORTS,
        listRemoves
    }),
    /**
     * Actions init data of reports when loadpage or show report detail
     * -----------------------------------------
     * @author : QuanHVM - 2022/07/21 - create
     * @param  : {Array} error - Data of error
     * @returns: {Object} - Action to set data checkbox of reports when event change input checkbox
     * @access : public
     */
    InitDataReportDetail: (id) => ({
        type: Types.SHOW_DATA_REPORT_INIT,
        id
    }),
    /**
     * Actions change data of report detail when get data success
     * -----------------------------------------
     * @author : QuanHVM - 2022/07/25 - create
     * @param  : {Array} reports - Data of report detail
     * @returns: {Object} - Action to change data of report detail when get data success
     * @access : public
     */
    GetReportDetailSuccess: (report) => ({
        type: Types.FETCHING_REPORT_DETAIL_SUCCESS,
        data: report
    }),
    /**
     * Actions change data of report detail when get data failure
     * -----------------------------------------
     * @author : QuanHVM - 2022/07/25 - create
     * @param  : {Array} reports - Data of report detail
     * @returns: {Object} - Action to reset data of report detail when get data failure
     * @access : public
     */
    GetReportDetailFailure: (error) => ({
        type: Types.FETCHING_REPORT_DETAIL_FAILURE,
        data: error
    }),
    /**
     * Actions insert data of report detail when get data success
     * -----------------------------------------
     * @author : QuanHVM - 2022/07/25 - create
     * @param  : {Array} reports - Data of report detail
     * @returns: {Object} - Action to change data of report detail when get data success
     * @access : public
     */
    PostReport: (report) => ({
        type: Types.ADD_REPORT,
        report
    }),
    /**
     * Actions insert data of report detail when get data success
     * -----------------------------------------
     * @author : QuanHVM - 2022/07/27 - create
     * @param  : {Array} reports - Data of report detail
     * @returns: {Object} - Action to change data of report detail when get data success
     * @access : public
     */
    IsShowPopupReport: () => ({
        type: Types.IS_SHOW_POPUP_REPORT_DETAIL
    }),
    /**
     * Actions clear data of reports
     * -----------------------------------------
     * @author : QuanHVM - 2022/07/27 - create
     * @param  : {Array} reports - Data of reports when search
     * @returns: {Object} - Action to search data of reports
     * @access : public
     */
    ClearStorage: () => ({
        type: Types.CLEAR_STORAGE
    })
}

export default Actions;